/*
 * @Author: 孙培国
 * @Date: 2023-01-13 18:05:22
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-06-05 13:31:56
 * @FilePath: \dataplaform\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'login',
  component: () => import('../views/login/loginView.vue')
},
{
  path: '/home',
  name: 'home',
  component: () => import('../views/HomeView.vue'),
  redirect: '/homePageView',
  children: [
    // 首页
    {
      path: '/homePageView',
      name: 'homePage',
      component: () => import('../views/components/homePageView.vue')
    },
    // 公告
    {
      path: '/NoticeView',
      name: 'NoticeView',
      component: () => import('../views/components/NoticeView.vue')
    },
    // 角色管理
    {
      path: '/role',
      component: () => import('@/views/roleMagt/roleMagt.vue'),
      name: 'roleMagt'
    },
    // 人员管理
    {
      path: '/admin',
      name: 'adminMagt',
      component: () => import('@/views/adminMagt/adminMagt.vue')
    },
    // 菜单管理
    {
      path: '/menu',
      name: 'authorityMagt',
      component: () => import('@/views/menuMagt/menuMagtView.vue')
    },
    // 操作日志
    {
      path: '/operationLog',
      name: 'operationLog',
      component: () => import('@/views/operationLog/operationLog.vue')
    },
    // 资源管理
    {
      path: '/resource',
      name: 'resource',
      component: () => import('@/views/resource/resourceView.vue')
    },
    // 字典管理
    {
      path: '/dictionary',
      name: 'dictionaryManagement',
      component: () => import('@/views/dictionaryManagement/dictionaryManagementView')
    },
    // 区域管理
    {
      path: '/region',
      name: 'region',
      component: () => import('@/views/region/regionView.vue')
    },
    // 站点管理
    {
      path: '/site',
      name: 'site',
      component: () => import('@/views/site/siteView.vue')
    },
    // 企业管理
    {
      path: '/enterprise',
      name: 'enterprise',
      component: () => import('@/views/enterprise/enterpriseView.vue')
    },
    // 企业管理 - 企业详情
    {
      path: '/enterpriseDetails',
      name: 'enterpriseDetails',
      component: () => import('@/views/enterprise/children/enterpriseDetailsView.vue')
    },
    // 设备管理
    {
      path: '/device',
      name: 'device',
      component: () => import('@/views/device/deviceView.vue')
    },
    // 因子管理
    {
      path: '/factor',
      name: 'factor',
      // component: () => import('@/views/factor/factorView.vue')
      component: () => import('@/views/factor/factorView_n.vue')
    },
    // 工业区管理
    {
      path: '/industrial',
      name: 'industrial',
      component: () => import('@/views/industrial/industrialView.vue')
    },
    // 数据查询 - 数据概览
    {
      path: '/dataOverview',
      name: 'dataOverview',
      component: () => import('../views/dataQuery/dataOverviewView.vue')
    },
    // 数据查询 - 历史数据
    {
      path: '/historicalData',
      name: 'historicalData',
      component: () => import('../views/dataQuery/historicalDataView.vue')
    },
    // 数据查询 - 气象数据
    {
      path: '/meteorologicalData',
      name: 'meteorologicalData',
      component: () => import('../views/dataQuery/meteorologicalDataView.vue')
    },
    // 数据查询 - 污染源数据
    {
      path: '/pollutionSourceData',
      name: 'pollutionSourceData',
      component: () => import('../views/dataQuery/pollutionSourceDataView.vue')
    },
    // 数据管理 - 数据审核
    {
      path: '/dataReview',
      name: 'dataReview',
      component: () => import('../views/dataManagement/dataReview/dataReviewView.vue')
    },
    // 数据管理 - 数据审核 - 审核详情
    {
      path: '/dataReviewDetails',
      name: 'dataReviewDetails',
      component: () => import('../views/dataManagement/dataReview/children/dataReviewDetailsView.vue')
    },
    // 数据管理 - 数据质控
    {
      path: '/dataQuailty',
      name: 'dataQuailty',
      component: () => import('../views/dataManagement/dataReview/dataQuailtyView.vue')
    },
    // 数据管理 - 审核评分
    {
      path: '/auditScore',
      name: 'auditScore',
      component: () => import('../views/dataManagement/dataReview/auditScoreView.vue')
    },
    // 数据管理 - 审核报告
    {
      path: '/auditReport',
      name: 'auditReport',
      component: () => import('../views/dataManagement/dataReview/auditReportView.vue')
    },
    // 数据管理 - 数据统计
    {
      path: '/dataStatistics',
      name: 'dataStatistics',
      component: () => import('../views/dataManagement/dataReport/dataStatisticsView.vue')
    },
    // 数据管理 - 报表管理
    {
      path: '/reportManage',
      name: 'reportManage',
      component: () => import('../views/dataManagement/dataReport/reportManageView.vue')
    },
    // 数据管理 - 站点级报表管理
    {
      path: '/siteLevelReport',
      name: 'siteLevelReport',
      component: () => import('../views/dataManagement/dataReport/siteLevelReportView.vue')
    },
    // 数据管理 - 饼图分析
    {
      path: '/pieChart',
      name: 'pieChart',
      component: () => import('../views/dataManagement/dataReport/pieChartView.vue')
    },
    // 数据管理 - 固化报表
    {
      path: '/SolidifyReport',
      name: 'SolidifyReport',
      component: () => import('../views/dataManagement/dataReport/SolidifyReportView.vue')
    },
    // 报警管理 - 报警消息
    {
      path: '/alarmMessage',
      name: 'alarmMessage',
      component: () => import('../views/alarmManagement/alarmMessageView.vue')
    },
    // 报警管理 - 报警消息 - 报警详情
    {
      path: '/alarmMessageDetails',
      name: 'alarmMessageDetails',
      component: () => import('../views/alarmManagement/children/alarmMessageDetailsView.vue')
    },
    // 报警管理 - 短信发送
    {
      path: '/smsSending',
      name: 'smsSending',
      component: () => import('../views/alarmManagement/smsSendingView.vue')
    },
    // 报警管理 - 历史超标统计
    {
      path: '/historical',
      name: 'historical',
      component: () => import('../views/alarmManagement/historicalView.vue')
    },
    // 运维管理 - 设备监控
    {
      path: '/EquipmentMonitoring',
      name: 'EquipmentMonitoring',
      component: () => import('../views/operationManagement/equipmentMonitoringView.vue')
    },
    // 运维管理 - 运维管理
    {
      path: '/maintenanceAdministration',
      name: 'operationManagement',
      component: () => import('../views/operationManagement/operationManagementView.vue')
    },
    // 运维管理 - 运维统计
    {
      path: '/maintenanceStatistics',
      name: 'maintenanceStatistics',
      component: () => import('../views/operationManagement/maintenanceStatisticsView.vue')
    },
    // 通用分析 - 时间序列
    {
      path: '/timeSeries',
      name: 'timeSeries',
      component: () => import('../views/statisticalAnalysis/generalAnalysisFL/timeSeriesView.vue')
    },
    // 统计分析 - 报告汇总
    {
      path: '/reportSummary',
      name: 'reportSummary',
      component: () => import('../views/statisticalAnalysis/statisticalAnalysisFL/reportSummaryView.vue')
    },
    // 通用分析 - 均值分析
    {
      path: '/meanValue',
      name: 'meanValue',
      component: () => import('../views/statisticalAnalysis/generalAnalysisFL/meanValueAnalysisView.vue')
    },
    // 通用分析 - 数据分布
    {
      path: '/dataDistribution',
      name: 'dataDistribution',
      component: () => import('../views/statisticalAnalysis/generalAnalysisFL/dataDistributionView.vue')
    },
    // 通用分析 - 气象分析
    {
      path: '/Meteorological',
      name: 'Meteorological',
      component: () => import('../views/statisticalAnalysis/generalAnalysisFL/meteorologicalAnalysisView.vue')
    },
    // 通用分析 - 光化学分析
    {
      path: '/Photochemical',
      name: 'Photochemical',
      component: () => import('../views/statisticalAnalysis/generalAnalysisFL/photochemicalAnalysisView.vue')
    },
    // 通用分析 - 相关性分析
    {
      path: '/correlation',
      name: 'correlation',
      component: () => import('../views/statisticalAnalysis/generalAnalysisFL/correlationView.vue')
    },
    // 通用分析 - PMF源分析
    {
      path: '/PMF',
      name: '/PMF',
      component: () => import('../views/statisticalAnalysis/generalAnalysisFL/pmfView.vue')
    },
    // 区整治
    {
      path: '/renvoate',
      name: '/renvoate',
      component: () => import('../views/renvoate/renvoateView.vue')
    }
    // // 系统配置
    // {
    //   path: '/SysConfig',
    //   name: 'home',
    //   component: () => import('../views/SysConfig/sysConfig.vue'),
    //   redirect: '/configurationOfhourlybct',
    //   children: [
    //     // 小时播报管控模板配置
    //     {
    //       path: '/configurationOfhourlybct',
    //       name: 'configurationOfhourlybct',
    //       component: () => import('../views/SysConfig/children/configurationOfhourlybct.vue')
    //     },
    //     // 目标累计数据人工校验
    //     {
    //       path: '/manualverificationOtcd',
    //       name: 'manualverificationOtcd',
    //       component: () => import('../views/SysConfig/children/manualverificationOtcd.vue')
    //     },
    //     // 巡查事件模板配置
    //     {
    //       path: '/patrolEventTemplateConfiguration',
    //       name: 'patrolEventTemplateConfiguration',
    //       component: () => import('../views/SysConfig/children/patrolEventTemplateConfiguration.vue')
    //     },
    //     // 空气质量年度目标设置
    //     {
    //       path: '/settingofAnnualqo',
    //       name: 'settingofAnnualqo',
    //       component: () => import('../views/SysConfig/children/settingofAnnualqo.vue')
    //     }
    //   ]
    // }
  ]
},
// GIS服务
{
  path: '/GisView',
  name: 'GisView',
  component: () => import('../views/Gis/gisView.vue'),
  redirect: '/airQuality',
  children: [
    // 污染源信息
    {
      path: '/PollutionSource',
      name: 'PollutionSource',
      component: () => import('../views/Gis/children/PollutionSource.vue')
    },
    // 大气质量
    {
      path: '/airQuality',
      name: 'airQuality',
      component: () => import('../views/Gis/children/airQuality.vue')
    },
    // 超标报警
    {
      path: '/overLimitAlarm',
      name: 'overLimitAlarm',
      component: () => import('../views/Gis/children/overLimitAlarm.vue')
    },
    // 模型模拟
    {
      path: '/modelSimulation',
      name: 'modelSimulation',
      component: () => import('../views/Gis/children/modelSimulation.vue')
    }
  ]
},
// 后台管理平台
{
  path: '/en-manager',
  name: 'en-manager',
  component: () => import('../views/en-manager/en-manager.vue'),
  redirect: '/en-patrol-mapMonitoring',
  children: [

    // 首页
    {
      path: '/en-home',
      name: 'en-home',
      component: () => import('../views/en-manager/children/en-home.vue')
    },
    // 人员管理
    {
      path: '/hbadmin',
      name: 'adminMagt2',
      component: () => import('@/views/adminMagt/adminMagt.vue')
    },
    // 操作日志
    {
      path: '/hboperationLog',
      name: 'operationLog',
      component: () => import('@/views/operationLog/operationLog.vue')
    },
    // 菜单管理
    {
      path: '/hbmenu',
      name: 'authorityMagt2',
      component: () => import('@/views/menuMagt/menuMagtView.vue')
    },
    // 角色管理
    {
      path: '/hbrole',
      component: () => import('@/views/roleMagt/roleMagt.vue'),
      name: 'roleMagt2'
    },
    // 部门管理
    {
      path: '/departmentManagement',
      component: () => import('../views/depManagement/en-departmentManagement.vue'),
      name: 'departmentManagement'
    },
    // 站点管理
    {
      path: '/hbsite',
      name: 'site2',
      component: () => import('@/views/site/siteView.vue')
    },
    // 字典管理
    {
      path: '/hbdictionary',
      name: 'dictionaryManagement2',
      component: () => import('@/views/dictionaryManagement/dictionaryManagementView')
    },
    // 资源管理
    {
      path: '/hbresource',
      name: 'hbresource2',
      component: () => import('@/views/resource/resourceView.vue')
    },
    // 全国数据
    {
      path: '/en-National',
      name: 'en-National',
      component: () => import('../views/en-manager/children/en-National.vue')
    },
    // 研判分析
    {
      path: '/en-analysis',
      name: 'en-analysis',
      component: () => import('../views/en-manager/children/en-analysis.vue')
    },
    // 实时调度
    {
      path: '/en-scheduling',
      name: 'en-scheduling',
      component: () => import('../views/en-manager/children/en-scheduling.vue')
    },
    // 站点对比
    {
      path: '/en-siteComparison',
      name: 'en-siteComparison',
      component: () => import('../views/en-manager/children/en-siteComparison.vue')
    },
    // 改善情况
    {
      path: '/en-improvement',
      name: 'en-improvement',
      component: () => import('../views/en-manager/children/en-improvement/en-improvement.vue')
    },
    // 人工会商
    {
      path: '/en-manualCon',
      name: 'en-manualCon',
      component: () => import('../views/en-manager/children/en-manualCon/index.vue')
    },
    // 空气质量日历
    {
      path: '/en-calendar',
      name: 'en-calendar',
      component: () => import('../views/en-manager/children/en-calendar/en-calendar.vue')
    },
    // 累计分析
    {
      path: '/en-cumulativeAnalysis',
      name: 'en-cumulativeAnalysis',
      component: () => import('../views/en-manager/children/en-cumulativeAnalysis/en-cumulativeAnalysis.vue')
    },
    // 年度对比
    {
      path: '/en-annualComparison',
      name: 'en-annualComparison',
      component: () => import('../views/en-manager/children/en-annualComparison.vue')
    },
    // 空间插值
    {
      path: '/en-spatialInterpolation',
      name: 'en-spatialInterpolation',
      component: () => import('../views/en-manager/children/en-spatialInterpolation.vue')
    },
    // 小时播报/en-hourlyBroadcast
    {
      path: '/en-hourlyBroadcast',
      name: 'en-hourlyBroadcast',
      component: () => import('../views/en-manager/children/en-hourlyBroadcast/index.vue')
    },
    {
      path: '/en-projectStatistics',
      name: 'en-projectStatistics',
      component: () => import('../views/en-manager/children/en-projectStatistics/index.vue')
    },
    // 今日管控
    {
      path: '/en-TodayControl',
      name: 'en-TodayControl',
      component: () => import('../views/en-manager/children/TodayControl/TodayControl.vue')
    },
    // 管控记录
    {
      path: '/en-controlRecords',
      name: 'en-controlRecords',
      component: () => import('../views/en-manager/children/controlRecords/en-controlRecords.vue')
    },
    // 整点统计
    {
      path: '/en-hourlyStatistics',
      name: 'en-hourlyStatistics',
      component: () => import('../views/en-manager/children/en-hourlyStatistics/index.vue')
    },
    // 污染玫瑰
    {
      path: '/en-pollutionRose',
      name: 'en-pollutionRose',
      component: () => import('../views/en-manager/children/en-pollutionRose/index.vue')
    },
    // 月均矩阵
    {
      path: '/en-monthMatrix',
      name: 'en-monthMatrix',
      component: () => import('../views/en-manager/children/en-monthMatrix/index.vue')
    },
    // 首要污染物
    {
      path: '/en-pollutant',
      name: 'en-pollutant',
      component: () => import('../views/en-manager/children/en-pollutant/en-pollutant.vue')
    },
    // 城市排名
    {
      path: '/en-cityRanking',
      name: 'en-cityRanking',
      component: () => import('../views/en-manager/children/en-city/en-cityRanking.vue')
    },
    // 巡查督导 - 污染源台账
    {
      path: '/en-patrol-account-list',
      name: 'en-patrol-account-list',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-account-list.vue')
    },
    // 巡查督导 - 巡查记录
    {
      path: '/en-patrol-record-list',
      name: 'en-patrol-record-list',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-record-list.vue')
    },
    // 巡查督导 - 巡查统计
    {
      path: '/en-patrol-statistics',
      name: 'en-patrol-statistics',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-statistics.vue')
    },
    // 巡查督导 - 统计通报
    {
      path: '/en-patrol-statistics-notification',
      name: 'en-patrol-statistics-notification',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-statistics-notification.vue')
    },
    // 巡查督导 - 巡查录入
    {
      path: '/en-patrol-register',
      name: 'en-patrol-register',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-register.vue')
    },
    // 巡查督导 - 巡查记录录入
    {
      path: '/en-patrol-record-register',
      name: 'en-patrol-record-register',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-record-register.vue')
    },
    // 巡查督导 - 巡查记录编辑
    {
      path: '/en-patrol-record-edit-register',
      name: 'en-patrol-record-edit-register',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-record-edit-register.vue')
    },
    // 巡查督导 - 污染源标绘
    {
      path: '/en-patrol-mapping',
      name: 'en-patrol-mapping',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-mapping-list.vue')
    },
    // 巡查督导 - 整改统计
    {
      path: '/en-patrol-rect-list',
      name: 'en-patrol-rect-list',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-rect-list.vue')
    },
    // 巡查督导 - 巡查通报
    {
      path: '/en-patrol-notify-list',
      name: 'en-patrol-notify-list',
      component: () => import('../views/en-manager/children/en-patrol/en-patrol-notify-list.vue')
    },
    // 地图监测
    {
      path: '/en-patrol-mapMonitoring',
      name: 'en-patrol-mapMonitoring',
      component: () => import('../views/mapMonitoring/mapMonitoring.vue')
    },
    // 在线学习 - 标准库类别
    {
      path: '/en-library-catogary',
      name: 'en-library-catogary',
      component: () => import('../views/en-manager/children/en-library/en-library-catogary.vue')
    },
    // 在线学习 - 标准库
    {
      path: '/en-library-management',
      name: 'en-library',
      component: () => import('../views/en-manager/children/en-library/en-library.vue')
    },
    // 在线学习 - 在线学习
    {
      path: '/en-study',
      name: 'en-study',
      component: () => import('../views/en-manager/children/en-study/en-study.vue')
    },
    // 在线学习 - 在线考试
    {
      path: '/en-examination',
      name: 'en-examination',
      component: () => import('../views/en-manager/children/en-examination/en-examination.vue')
    },
    // 在线学习 - 考试管理
    {
      path: '/en-examinationList',
      name: 'en-examinationList',
      component: () => import('../views/en-manager/children/en-examination/en-examinationList.vue')
    },
    // 在线学习 - 题库
    {
      path: '/en-Question',
      name: 'en-Question',
      component: () => import('../views/en-manager/children/en-examination/en-Question.vue')
    },
    // 在线学习 - 文件位置管理
    {
      path: '/en-study-catogary',
      name: 'en-study-catogary',
      component: () => import('../views/en-manager/children/en-study/en-study-catogary.vue')
    },
    // 预报预警-模式预报
    {
      path: '/en-forecast',
      name: 'en-forecast',
      component: () => import('../views/en-manager/children/ForecastAndEarlyWarning/en-forecast.vue')
    },
    // 预报预警-国内预报
    {
      path: '/en-domesticForecast',
      name: 'en-domesticForecast',
      component: () => import('../views/en-manager/children/en-domesticForecast/en-index.vue')
    },
    // 预报预警-国外预报
    {
      path: '/en-foreignForecast',
      name: 'en-foreignForecast',
      component: () => import('../views/en-manager/children/en-foreignForecast/en-index.vue')
    },
    // 预报预警 - 监控预警
    {
      path: '/en-steward-alarm-list',
      name: 'en-steward-alarm-list',
      component: () => import('../views/en-manager/children/en-alarm/en-steward-alarm-list.vue')
    },
    // 预报预警 - 预警统计
    {
      path: '/en-steward-alarm-statistics',
      name: 'en-steward-alarm-statistics',
      component: () => import('../views/en-manager/children/en-alarm/en-steward-alarm-statistics.vue')
    },
    // 系统配置
    {
      path: '/SysConfig',
      name: 'SysConfig',
      component: () => import('../views/SysConfig/sysConfig.vue'),
      redirect: '/configurationOfhourlybct',
      children: [
        // 小时播报管控模板配置
        {
          path: '/configurationOfhourlybct',
          name: 'configurationOfhourlybct',
          component: () => import('../views/SysConfig/children/configurationOfhourlybct.vue')
        },
        // 目标累计数据人工校验
        {
          path: '/manualverificationOtcd',
          name: 'manualverificationOtcd',
          component: () => import('../views/SysConfig/children/manualverificationOtcd.vue')
        },
        // 巡查事件模板配置
        {
          path: '/patrolEventTemplateConfiguration',
          name: 'patrolEventTemplateConfiguration',
          component: () => import('../views/SysConfig/children/patrolEventTemplateConfiguration.vue')
        },
        // 空气质量年度目标设置
        {
          path: '/settingofAnnualqo',
          name: 'settingofAnnualqo',
          component: () => import('../views/SysConfig/children/settingofAnnualqo.vue')
        }
      ]
    }
  ]
},

{
  path: '/en-root',
  name: 'en-root',
  component: () => import('../views/en-manager/en-root.vue')
}
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
